// import React, { useState } from "react";
// import rightArrow from "../../../../assets/images/homepage/setting/ManageUser/rightArrow.svg";
// import rightArrowDark from "../../../../assets/images/homepage/setting/ManageUser/rightArrowDark.svg";
// import "./manageRole.scss";
// import useTheme from "hooks/observer";
// import nodata from "assets/images/homepage/setting/No data.svg";
// import Input from "components/Input/index";
// import Button from "components/Button/index";
// import useScreenMobile from "hooks/useScreen";
// import RoleTable from "./RoleTable/index";
// import Role from "./Role/index";
// import EditRole from "./RoleEdit/index";
// import DeleteModal from "components/DeleteModal/index";
// import EmptyRole from "./EmptyRole/index";

// // TODO: Replace initialRoles with API call to fetch roles data
// // Example: fetchRoles().then(data => setRoles(data));
// const initialRoles = [
//   // {
//   //   roles: "Admin",
//   //   users: [
//   //     "John Doe",
//   //     "Esther Howard",
//   //     "Jane Cooper",
//   //     "Floyd Miles",
//   //     "Extra User"
//   //   ],
//   //   team: ["Design Team", "Dev Team", "Sales Team"],
//   //   operations: ["Product Designer", "Frontend Developer", "QA Analyst"]
//   // },
//   // {
//   //   roles: "Admin",
//   //   users: [
//   //     "John Doe",
//   //     "Esther Howard",
//   //     "Jane Cooper",
//   //     "Floyd Miles",
//   //     "Extra User"
//   //   ],
//   //   team: ["Design Team", "Dev Team", "Sales Team"],
//   //   operations: ["Product Designer", "Frontend Developer", "QA Analyst"]
//   // },
//   // {
//   //   roles: "Admin",
//   //   users: [
//   //     "John Doe",
//   //     "Esther Howard",
//   //     "Jane Cooper",
//   //     "Floyd Miles",
//   //     "Extra User"
//   //   ],
//   //   team: ["Design Team", "Dev Team", "Sales Team"],
//   //   operations: ["Product Designer", "Frontend Developer", "QA Analyst"]
//   // }
// ];

// function ManageRole({ setManageUser }) {
//   const [roles, setRoles] = useState(initialRoles);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editModal, setEditModal] = useState(false);
//   const [showDelete, setShowDelete] = useState(false);
//   const [selectedRoleIndex, setSelectedRoleIndex] = useState(null);
//   const [roleToDelete, setRoleToDelete] = useState(null);

//   const theme = useTheme();
//   const isMobile = useScreenMobile({ size: 992 });

//   // TODO: Fetch available teams from API instead of deriving from roles
//   // Example: fetchTeams().then(data => setAvailableTeams(data));
//   const availableTeams = Array.from(
//     new Set(roles.flatMap((role) => role.team))
//   ).map((team) => ({ team }));

//   // TODO: Implement API-based search filtering
//   // Example: searchRoles(searchQuery).then(data => setFilteredRoles(data));
//   const filteredRoles = roles.filter(
//     (role) =>
//       role.roles.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       role.users.some((user) =>
//         user.toLowerCase().includes(searchQuery.toLowerCase())
//       ) ||
//       role.team.some((team) =>
//         team.toLowerCase().includes(searchQuery.toLowerCase())
//       ) ||
//       role.operations.some((operation) =>
//         operation.toLowerCase().includes(searchQuery.toLowerCase())
//       )
//   );

//   const handleShowDelete = (roleIndex) => {
//     setRoleToDelete(roleIndex);
//     setShowDelete(true);
//   };

//   const cancelShowDelete = () => {
//     setShowDelete(false);
//     setRoleToDelete(null);
//   };

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const handleClearSearch = () => {
//     setSearchQuery("");
//   };

//   const handleModal = () => {
//     setIsModalOpen(!isModalOpen);
//   };

//   // TODO: Implement API call to delete role
//   // Example: deleteRole(roleToDelete).then(() => setRoles(updatedRoles));
//   const handleDelete = () => {
//     if (roleToDelete !== null) {
//       setRoles(roles.filter((_, index) => index !== roleToDelete));
//       setRoleToDelete(null);
//       setShowDelete(false);
//     }
//   };

//   const handleEditRole = (roleIndex) => {
//     setSelectedRoleIndex(roleIndex);
//     setEditModal(true);
//   };

//   // TODO: Implement API call to update role
//   // Example: updateRole(selectedRoleIndex, updatedRole).then(() => setRoles(updatedRoles));
//   const handleUpdateRole = (updatedRole) => {
//     setRoles((prev) =>
//       prev.map((role, index) =>
//         index === selectedRoleIndex ? updatedRole : role
//       )
//     );
//     setEditModal(false);
//   };

//   // TODO: Implement API call to add new role
//   // Example: addRole(newRole).then(() => setRoles([...roles, newRole]));
//   const handleAddRole = (newRole) => {
//     setRoles((prev) => [...prev, newRole]);
//   };

//   return (
//     <div
//       className={`ManageRole ${roles.length === 0 || isModalOpen || editModal ? "ManageRoleEmpty" : ""} `}
//     >
//       <div className="manageUserHeader">
//         <p onClick={() => setManageUser("")} style={{ cursor: "pointer" }}>
//           Settings
//         </p>
//         <img
//           src={theme === "light" ? rightArrow : rightArrowDark}
//           alt="arrow"
//         />
//         <p className="user">Manage Roles</p>
//       </div>
//       <div className="title">
//         <p>Manage Roles</p>
//       </div>
//       {roles.length > 0 && (
//         <div className="searchBox">
//           <div className="searchInputWrapper">
//             <Input
//               searchIconBool={true}
//               width="300px"
//               placeholder="Search by role name"
//               value={searchQuery}
//               onChange={handleSearchChange}
//             />
//             {searchQuery && (
//               <button className="clearSearchButton" onClick={handleClearSearch}>
//                 ✕
//               </button>
//             )}
//           </div>
//           <Button
//             type="violet"
//             title="+ Add Role"
//             width={isMobile ? "100%" : "14%"}
//             onClick={handleModal}
//           />
//         </div>
//       )}

//       {isModalOpen && (
//         <Role handleCancel={handleModal} onAddRole={handleAddRole} />
//       )}

//       {editModal && (
//         <EditRole
//           handleCancel={() => setEditModal(false)}
//           onUpdateRole={handleUpdateRole}
//           role={roles[selectedRoleIndex]}
//           availableTeams={availableTeams}
//         />
//       )}

//       {showDelete && (
//         <DeleteModal
//           handleCancel={cancelShowDelete}
//           title="Are you sure you want to delete this Role permanently?"
//           handleSave={handleDelete}
//           mockClass={"manage"}
//         />
//       )}

//       {filteredRoles.length === 0 && roles.length > 0 ? (
//         <div className="noResults">
//           <img src={nodata} alt="no data" />
//           <p className="text">No Data Found</p>
//         </div>
//       ) : roles.length > 0 ? (
//         <RoleTable
//           roles={filteredRoles}
//           handleEditRole={handleEditRole}
//           handleShowDelete={handleShowDelete}
//         />
//       ) : (
//         <EmptyRole handleModal={handleModal} />
//       )}
//     </div>
//   );
// }

// export default ManageRole;

import React, { useEffect, useState } from "react";
import rightArrow from "../../../../assets/images/homepage/setting/ManageUser/rightArrow.svg";
import rightArrowDark from "../../../../assets/images/homepage/setting/ManageUser/rightArrowDark.svg";
import "./manageRole.scss";
import useTheme from "hooks/observer";
import nodata from "assets/images/homepage/setting/No data.svg";
import RoleTable from "./RoleTable/index";
import Role from "./Role/index";
import EditRole from "./RoleEdit/index";
import DeleteModal from "components/DeleteModal/index";
import EmptyRole from "./EmptyRole/index";
import { Role as IzRole } from "@induz/sdk";
import { useToast } from "components/Toaster/index";
import ShowPermissions from "./RoleTable/showPermissions";
// TODO: Replace initialRoles with API call to fetch roles data
// Example: fetchRoles().then(data => setRoles(data));
const initialRoles = [
  // {
  //   roles: "Admin",
  //   users: [],
  //   team: [],
  //   operations: [{ id: 1, name: "Code" }, { id: 2, name: "Debug" }]
  // },
];

function ManageRole({ setManageUser, searchQuery, setSearchQuery }) {
  const [roles, setRoles] = useState(initialRoles);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [showPermissionsModal, setShowPermissionsModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedRoleIndex, setSelectedRoleIndex] = useState(null);
  const [roleToDelete, setRoleToDelete] = useState(null);

  const theme = useTheme();
  const showToast = useToast();

  // Register the add role handler with the homepage (similar to ManageUser)
  useEffect(() => {
    window.addRoleHandler = () => setIsModalOpen(true);

    // Cleanup on unmount
    return () => {
      window.addRoleHandler = null;
    };
  }, []);

  const listRoles = async () => {
    const list_ = await IzRole.listRoles();
    // console.log("Fetched Roles from API:", list_); // Debug log to check API response
    return list_.map(
      (item_) => ({
        roles: item_.getName(),
        operations: item_.getPermissions().map(
          (strRole) =>
            strRole ? {
              role: strRole
            } : undefined
        ).filter(Boolean)
      })
    );
  };

  useEffect(() => {
    const listRoles_ = async () => {
      try {
        const list_ = await listRoles();
        setRoles(list_);
      } catch (error) {
        showToast(error.message, " error");
      }
    };
    listRoles_();
  }, []);

  // TODO: Fetch available teams from API instead of deriving from roles
  // Example: fetchTeams().then(data => setAvailableTeams(data));
  const availableTeams = [];

  // Updated search logic to handle operations as objects
  const filteredRoles = roles.filter(
    (role) =>
      role.roles.toLowerCase().includes(searchQuery.toLowerCase()) ||
      role.operations.some((op) =>
        op.role && op.role.toLowerCase().includes(searchQuery.toLowerCase())
      )
  );

  const handleShowDelete = (roleIndex) => {
    setRoleToDelete(roleIndex);
    setShowDelete(true);
  };

  const cancelShowDelete = () => {
    setShowDelete(false);
    setRoleToDelete(null);
  };

  const handleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // TODO: Implement API call to delete role
  // Example: deleteRole(roleToDelete).then(() => setRoles(updatedRoles));
  const handleDelete = async () => {
    if (roleToDelete !== null) {
      setRoleToDelete(null);
      setShowDelete(false);
      await IzRole.removeRole(roles[roleToDelete].roles);
      setRoles(await listRoles());
    }
  };

  const handleEditRole = (roleIndex) => {
    setSelectedRoleIndex(roleIndex);
    setEditModal(true);
  };
  const handleShowPermissions = (roleIndex) => {
    setSelectedRoleIndex(roleIndex);
    setShowPermissionsModal(true);
  };

  // TODO: Implement API call to update role
  // Example: updateRole(selectedRoleIndex, updatedRole).then(() => setRoles(updatedRoles));
  const handleUpdateRole = async (updatedRole) => {
    if (updatedRole.operations.length === 0) {
      showToast("Atleast one permission is required", "error");
      return;
    }
    // console.log("Operations ", updatedRole.operations, typeof updatedRole.operations);
    const operations = updatedRole.operations.map(
      (dictRole) => typeof dictRole === "string" ? dictRole : dictRole?.role ?? "No role"
    );
    await IzRole.updateRole(updatedRole.roles, operations);
    showToast("Role Updated Successfully", "success");
    setRoles(await listRoles());
    setEditModal(false);
  };

  // TODO: Implement API call to add new role
  // Example: addRole(newRole).then(() => setRoles([...roles, newRole]));
  const handleAddRole = async (newRole) => {
    try {
      const operations = newRole.operations.map(
        (dictRole) => dictRole.role
      );
      await IzRole.addRole(newRole.roles, operations);
      setRoles(await listRoles());
    } catch (error) {
      showToast(error?.message || "Failed to add role. Please try again.", "error");
    }
  };

  return (
    <div
      className={`ManageRole ${roles.length < 0 || isModalOpen || editModal ? "ManageRoleEmpty" : ""} `}
    >
      <div className="manageUserHeader">
        <p onClick={() => setManageUser("")} style={{ cursor: "pointer" }}>
          Settings
        </p>
        <img
          src={theme === "light" ? rightArrow : rightArrowDark}
          alt="arrow"
        />
        <p className="user">Manage Roles</p>
      </div>
      <div className="title">
        {/* <p>Manage Roles</p> */}
      </div>
      <div className="searchBox">
        {/* Search bar and Add Role button moved to homepage header */}
      </div>

      {isModalOpen && (
        <Role handleCancel={handleModal} onAddRole={handleAddRole} />
      )}

      {
        showPermissionsModal && (
          <ShowPermissions
            role={roles[selectedRoleIndex]}
            handleCancel={() => setShowPermissionsModal(false)}
          />
        )
      }


      {editModal && (
        <EditRole
          handleCancel={() => setEditModal(false)}
          onUpdateRole={handleUpdateRole}
          role={roles[selectedRoleIndex]}
          availableTeams={availableTeams}
        />
      )}

      {showDelete && (
        <DeleteModal
          handleCancel={cancelShowDelete}
          // title={`Are you sure you want to delete the role "${roles[roleToDelete]?.roles}" permanently?`}
          title={
            <>
              Are you sure you want to delete the role{" "}
              <span
                style={{
                  fontWeight: 700,
                  color: "#9B2FAB",
                  fontSize: "1.25rem",
                  lineHeight: 1.2,
                }}
              >
                {roles[roleToDelete]?.roles}
              </span>{" "}
              permanently?
            </>
          }
          handleSave={handleDelete}
          mockClass={"manage"}
        />
      )}

      {filteredRoles.length === 0 && roles.length > 0 ? (
        <div className="noResults">
          <img src={nodata} alt="no data" />
          <p className="text">No Data Found</p>
        </div>
      ) : roles.length >= 0 ? (
        <RoleTable
          roles={filteredRoles}
          handleShowPermissions={handleShowPermissions}
          handleEditRole={handleEditRole}
          handleShowDelete={handleShowDelete}
        />
      ) : (
        <EmptyRole handleModal={handleModal} />
      )}

    </div>
  );
}

export default ManageRole;